/**
 * Created by mgoria on 12/22/15.
 */

'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.IdentityProviderMismatchException = undefined;

var _Exception2 = require('./Exception');

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

/**
 * Thrown when passed identity provider name does not match provider name from identityMetadata
 */
let IdentityProviderMismatchException = exports.IdentityProviderMismatchException = function (_Exception) {
  _inherits(IdentityProviderMismatchException, _Exception);

  /**
   * @param {String} providerName
   * @param {String} identityMetadataProvider
   */
  function IdentityProviderMismatchException(providerName, identityMetadataProvider) {
    _classCallCheck(this, IdentityProviderMismatchException);

    return _possibleConstructorReturn(this, (IdentityProviderMismatchException.__proto__ || Object.getPrototypeOf(IdentityProviderMismatchException)).call(this, `Provider "${providerName}" does not match with identityMetadataProvider "${identityMetadataProvider}".`));
  }

  return IdentityProviderMismatchException;
}(_Exception2.Exception);


//////////////////
// WEBPACK FOOTER
// ../~/deep-security/lib.compiled/Exception/IdentityProviderMismatchException.js
// module id = 437
// module chunks = 0